import { render, staticRenderFns } from "./ObjectiveDetailPanel.vue?vue&type=template&id=20874a88&scoped=true"
import script from "./ObjectiveDetailPanel.vue?vue&type=script&lang=js"
export * from "./ObjectiveDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveDetailPanel.vue?vue&type=style&index=0&id=20874a88&prod&scoped=true&lang=css"
import style1 from "./ObjectiveDetailPanel.vue?vue&type=style&index=1&id=20874a88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20874a88",
  null
  
)

export default component.exports